module.exports = __webpack_public_path__ + "img/canbadge_rectangle_yoko.bf0b8184.png";